import {Column, Entity, JoinTable, ManyToMany, ManyToOne, OneToMany, PrimaryGeneratedColumn} from "typeorm"
import { JsonObject } from "../../transofrmers/JsonObject"
import { AssociatedProduct } from "./AssociatedProduct"
import { ProductPriceOverride } from "./ProductPriceOverride"
import { Error } from "../../interfaces/error"
import moment from "moment"

@Entity()
export class Product {

  constructor(init?:Partial<Product>) {
    Object.assign(this, init);
  }

	@PrimaryGeneratedColumn()
  id?: number
  
  @Column()
  name?: string

  @Column()
  xero_code?: string

  @Column()
  xero_name?: string

  @Column()
  product_description?: string

  @Column({ type: "varchar", length: 200, transformer: JsonObject })
  product_form_options?: any

  @Column({ type: "varchar", length: 200, transformer: JsonObject })
  product_form_template?: any

  @Column({ type: "varchar", length: 200, transformer: JsonObject })
  product_base_options?: any

  @OneToMany(() => AssociatedProduct, (ap) => ap.owningProduct, { cascade:true, onDelete: "CASCADE" })
  associatedProducts?: AssociatedProduct[]

  @OneToMany(() => ProductPriceOverride, (ppo) => ppo.product)
  priceOverrides?: ProductPriceOverride[]

  @Column({ nullable:true })
  image_url?: string

  @Column({ default:false })
  archived?: boolean

  @Column({ default:false })
  sortOrder?: number

  @Column({ default:false })
  group?: string

  price?:number

  adjustedPrice?:number

  errors?:Error[]

  accountCode?:string // used by xero for invoicing

  addError(error:string) {
    if(this.errors == undefined) {
      this.errors = [{ error:error, timestamp:moment() }]
    } else {
      this.errors.push({ error:error, timestamp:moment() })
    }
  }
	
}